import React from 'react'
import Link from 'next/link'
import { twMerge } from 'tailwind-merge'

import Box from '../box/box'
import { DEFAULT_LOCALE } from '@unreserved-frontend-v2/utils/locale'

export type LinksListItem = {
  title: string
  links: {
    id: string
    name: string
    url: string
    count: number
  }[]
}

export interface LinksListProps {
  items?: LinksListItem[]
  columns: number
  classNames?: string
}

export function LinksList({ items, columns, classNames }: LinksListProps) {
  return items?.length ? (
    <div data-testid="links-list" className={twMerge('flex flex-col gap-6', classNames)}>
      {items.map(({ title, links }) => {
        return (
          <React.Fragment key={title}>
            <p className="text-shades-600 text-lg font-bold md:text-xl">{title}</p>
            <div
              className={`grid`}
              style={{
                gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
              }}
            >
              {links.map(({ id, name, url, count }, i) => {
                const isFirstCol = (i + 1) % columns === 1
                const isLastCol = (i + 1) % columns === 0

                return (
                  <div
                    key={id}
                    className={twMerge(
                      `${isFirstCol || columns === 1 ? '' : 'pl-6'}`,
                      `${isLastCol ? '' : 'border-shades-200 border-r border-dashed pr-6'}`
                    )}
                  >
                    <div className={`flex justify-between pb-[9px]`}>
                      <Link href={url} className="truncate pr-2 underline" title={name}>
                        {name}
                      </Link>
                      <Box
                        colorVariant="neutral"
                        padding="py-[3px] px-[7px]"
                        className={twMerge(
                          'h-[21px] w-auto min-w-[21px] shrink-0 rounded-3xl text-center text-xs font-bold',
                          Number(count) > 9 ? 'indent-px' : ''
                        )}
                      >
                        {count.toLocaleString(DEFAULT_LOCALE)}
                      </Box>
                    </div>
                  </div>
                )
              })}
            </div>
          </React.Fragment>
        )
      })}
    </div>
  ) : null
}

export default LinksList
